// extracted by mini-css-extract-plugin
module.exports = {"banner":"VehicleRecallBanner-module__banner___3DMBs"};